import { cn } from "@/lib/utils";

// TODO: replace with the actual Airbnb host profile URL
const AIRBNB_PROFILE_URL = "https://www.airbnb.fr/";

interface AirbnbSuperhostBadgeProps {
  variant?: "default" | "compact" | "inline";
  className?: string;
  label?: string;
}

// Official Airbnb "Bélo" symbol
const AirbnbLogo = ({ className }: { className?: string }) => (
  <img src="/icons/airbnb-belo.png" alt="Airbnb" className={className} loading="lazy" decoding="async" />
);

export default function AirbnbSuperhostBadge({
  variant = "default",
  className,
  label = "Superhôte Airbnb",
}: AirbnbSuperhostBadgeProps) {
  const linkProps = {
    href: AIRBNB_PROFILE_URL,
    target: "_blank" as const,
    rel: "noopener noreferrer",
    "aria-label": "Voir notre profil Superhôte sur Airbnb",
  };

  if (variant === "inline") {
    return (
      <a
        {...linkProps}
        className={cn("inline-flex items-center gap-1.5 hover:opacity-80 transition-opacity", className)}
      >
        <AirbnbLogo className="h-3.5 w-3.5" />
        <span className="text-xs text-muted-foreground font-medium">{label}</span>
      </a>
    );
  }

  if (variant === "compact") {
    return (
      <a
        {...linkProps}
        className={cn("flex items-center gap-2 hover:opacity-80 transition-opacity w-fit", className)}
      >
        <AirbnbLogo className="h-4 w-4" />
        <span className="text-sm text-muted-foreground font-medium">{label}</span>
      </a>
    );
  }

  return (
    <a
      {...linkProps}
      className={cn(
        "flex items-center gap-3 px-4 py-2.5 rounded-full border border-gold/20 bg-gold/5 backdrop-blur-sm w-fit hover:opacity-80 transition-opacity",
        className
      )}
    >
      <AirbnbLogo className="h-4 w-4 shrink-0" />
      <span className="text-sm font-medium text-foreground/80">{label}</span>
    </a>
  );
}
